"use client";

import "./AvatarSkeleton.scss";
import { Col } from "@/components";
import clsx from "clsx";

type AvatarSkeletonProps = {
  size?: "1" | "2" | "3";
};

export const AvatarSkeleton = ({ size = "2" }: AvatarSkeletonProps) => {
  const AVATAR_SKELETON_SIZES = {
    "1": "avatar-skeleton-circle-large",
    "2": "avatar-skeleton-circle-medium",
    "3": "avatar-skeleton-circle-small",
  };

  const circleClasses = clsx(
    "avatar-skeleton-circle pulse",
    AVATAR_SKELETON_SIZES[size],
  );

  return (
    <button className="bg-transparent border-none base-row align-items-center gap-x8">
      <div className={circleClasses}></div>
      <Col style={{ textAlign: "left" }} justifyContent={"flex-start"}>
        <div className="avatar-skeleton-name pulse"></div>
      </Col>
    </button>
  );
};
